import React from 'react';
import './ShowLogPopUp.css';
// componenets
import PrimarySolidButton from '../../Buttons/PrimarySolidButton/PrimarySolidButton';
import PrimaryMutedButton from '../../Buttons/PrimaryMutedButton/PrimaryMutedButton';

import frame from '../../../assets/frame.png';
import { baseUrl } from '../../../services/BaseUrl';


const ShowLogPopUpAR =({onClose,onRegisterClick,onLoginClick})=>{

    return(
        <div className="login-popup-overlay">
        <div className="register-pop-up pop-up-gap">

            <button className="close-button-u" onClick={onClose}>
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                    <path d="M21 7L7 21" stroke="#666666" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M7 7L21 21" stroke="#666666" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </button>

            <div className="popup-image">
                <img src={frame} alt="Login/Register" />
                <p className="popup-text">
                    يرجى تسجيل الدخول أو إنشاء حساب لحجز الخدمة الخاصة بك.
                </p>
            </div>

            <div className="popup-buttons">
                <PrimaryMutedButton label={"إنشاء حساب"} onClick={onRegisterClick}/>
                <PrimarySolidButton label={"تسجيل الدخول"} onClick={onLoginClick}/>
            </div>
        </div>
        </div>
    )
}
export default ShowLogPopUpAR;